@if (!hasExpired) {
  <span class="p-5 uppercase bg-transparent rounded text-blue-light" @fadeIn>
    New!
  </span>
}